/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlDomain
 */
export interface ControlDomain {
    /**
     * 
     * @type {string}
     * @memberof ControlDomain
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDomain
     */
    displayName: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDomain
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDomain
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlDomain
     */
    teamId: string;
}

/**
 * Check if a given object implements the ControlDomain interface.
 */
export function instanceOfControlDomain(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "displayName" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function ControlDomainFromJSON(json: any): ControlDomain {
    return ControlDomainFromJSONTyped(json, false);
}

export function ControlDomainFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlDomain {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'displayName': json['displayName'],
        'id': json['id'],
        'name': json['name'],
        'teamId': json['teamId'],
    };
}

export function ControlDomainToJSON(value?: ControlDomain | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'displayName': value.displayName,
        'id': value.id,
        'name': value.name,
        'teamId': value.teamId,
    };
}

